import { type LucideProps } from 'lucide-react'

/**
 * Hierarchy Level 1 Icon
 *
 * Three stacked chevrons pointing up with the TOP chevron highlighted in gold.
 * Represents the highest organizational level (Company).
 *
 * Color: Gold (#D4AF37) - First place in medal hierarchy
 */
export function HierarchyLevel1({
  size = 24,
  className = '',
  ...props
}: LucideProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      className={className}
      {...props}
    >
      {/* Top chevron - bold gold (highlighted) */}
      {/* Color matches HIERARCHY_COLORS.gold in hierarchy-utils.ts */}
      <path
        d="M6 10 L12 4 L18 10"
        strokeWidth="2.5"
        stroke="#D4AF37"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Middle chevron - thin muted */}
      <path
        d="M6 15 L12 9 L18 15"
        strokeWidth="1.5"
        stroke="currentColor"
        opacity="0.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Bottom chevron - thin muted */}
      <path
        d="M6 20 L12 14 L18 20"
        strokeWidth="1.5"
        stroke="currentColor"
        opacity="0.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
